import axiosInstance from './axiosInstance'

export const getFooterStyleOptionById = (optionId) => {
  return axiosInstance.get(`/footer-style-options/${optionId}`)
}

export const getFooterStyleOptions = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.get(`/footer-style-options?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createFooterStyleOption = (data) => {
  return axiosInstance.post('/footer-style-options', data)
}

export const updateFooterStyleOption = (optionId, data) => {
  return axiosInstance.put(`/footer-style-options/${optionId}`, data)
}

export const deleteFooterStyleOption = (optionId) => {
  return axiosInstance.delete(`/footer-style-options/${optionId}`)
}
